import styles from './index.scss'
import { DpDescriptions } from '@/libs/components'
import { TotalPriceRender } from '../toolSubmit'
import { RightOutline } from 'antd-mobile-icons'

export interface IDpBusinessCommoditySettlement {
  textStyle?: React.CSSProperties //价格字体样式
  containerStyles?: React.CSSProperties //外层样式
  customStyles?: React.CSSProperties // 自定义样式
  onGotoSelectEquity: () => void // 是否有权益支付
  onGotoSelectDiscount: () => void // 优惠券
  data?: {
    productNum?: number | undefined;
    couponAmount?: string | number | undefined;
    equityPay: string | number; // 是否有权益支付
    supportCoupon?: boolean | undefined;
    showTotal?: boolean | undefined;
    exchangeType: number; // 支付类型
    exchangePrice: string | number // 价格
    pointPrice: string | number // 兑换价格
    redeemUnit: string // 租户单位
    totalAmount?: string | number // 总价
    equity?: {
      equityCode: string
      equityCouponCode: string
      equityName: string
      tips: string
    }
    discount?: {
      id: string
      cuoName: string
      tips: string
    }
    totalData: any
  } & { children?: React.ReactNode; }
}

const Settlement = (props: IDpBusinessCommoditySettlement) => {
  const code = props?.data?.equity?.equityCouponCode
  let _lastFour = ''
  if (code) {
    const start = code?.length - 4;
    _lastFour = code.substring(start)
  }
  return (
    <DpDescriptions title={'订单信息'} containerStyles={props?.containerStyles}>
      {
        [1, 8].includes(props?.data?.exchangeType || 0) &&  <DpDescriptions.Item label={'应付'}>￥{props?.data?.exchangePrice || '0.00'}</DpDescriptions.Item>
      }
      {
        [2, 4].includes(props?.data?.exchangeType || 0) &&  <DpDescriptions.Item label={'应付'}>{`${props?.data?.pointPrice || '0'} ${props?.data?.redeemUnit || '积分'}`}</DpDescriptions.Item>
      }
      {
        [5].includes(props?.data?.exchangeType || 0) &&  <DpDescriptions.Item label={'应付'}>￥{props?.data?.exchangePrice || '0.00'} + {`${props?.data?.pointPrice || '0'} ${props?.data?.redeemUnit || '积分'}`}</DpDescriptions.Item>
      }
      {
        !!props?.data?.equityPay &&
          <DpDescriptions.Item label={'权益券'}>
            <div className={styles['dp-business-commodity--settlement-flex']} onClick={props?.onGotoSelectEquity}>
              {props?.data?.equity?.equityCode ? (
                <div className={styles['dp-business-commodity--settlement-active']} style={props?.textStyle}>{props?.data?.equity?.equityName}({_lastFour})</div>
              ) : (
                <div className={styles['dp-business-commodity--settlement-text']}>{
                  props?.data?.equity?.tips || lang['请选择']
                }</div>
              )}
              {!!props?.onGotoSelectEquity ? <RightOutline className={styles['dp-business-commodity--settlement-arrows']}  /> : undefined}
            </div>
          </DpDescriptions.Item>
      }
      {
        props?.data?.exchangeType === 1 && props?.data?.supportCoupon &&
          <DpDescriptions.Item label={'优惠券'}>
            <div className={styles['dp-business-commodity--settlement-flex']} onClick={props?.onGotoSelectDiscount}>
              {props?.data?.discount?.id ? (
                <div className={styles['dp-business-commodity--settlement-active']} style={props?.textStyle}>{props?.data?.discount?.cuoName}</div>
              ) : (
                <div className={styles['dp-business-commodity--settlement-text']}>{
                  props?.data?.discount?.tips || lang['请选择']
                }</div>
              )}
             { !!props?.onGotoSelectDiscount ? <RightOutline className={styles['dp-business-commodity--settlement-arrows']}  /> : undefined}
            </div>
          </DpDescriptions.Item>
      }
      {
        props?.data?.equity?.equityCode && <DpDescriptions.Item label={'权益券扣减'}>{props?.data?.productNum}</DpDescriptions.Item>
      }
      {
        props?.data?.exchangeType === 1 && props?.data?.supportCoupon && props?.data?.discount?.id &&
          <DpDescriptions.Item label={'优惠金额'}>
            <div className={styles['dp-business-commodity--settlement-flex']}>
              <div className={styles['dp-business-commodity--settlement-active']} style={props?.textStyle}>￥{props?.data?.couponAmount ? `-${props?.data?.couponAmount}` : '0.00'}</div>
            </div>
          </DpDescriptions.Item>
      }
      {(props?.data?.showTotal || props?.data?.totalData) && props?.data?.exchangeType !== 3 &&
        <DpDescriptions.Item itemStyles={{ borderTop: `1px solid var(--tab-border-color, rgba(0, 0, 0, 0.05))`, marginTop: 8, paddingTop: 8, paddingBottom: 8, fontSize: 12 }}>
          合计：<span className={styles["dp-business-commodity--tool-total"]} style={{ paddingRight: 0}}>{TotalPriceRender({ data: {
            ...props?.data,
            ...props?.data?.totalData
          }})}</span>
        </DpDescriptions.Item>
      }
    </DpDescriptions>
  )
}

export default Settlement
